export function loginPath(returnTo?: string): string {
  if (!returnTo || !returnTo.startsWith('/') || returnTo.startsWith('//') || returnTo.startsWith('/auth') || returnTo.startsWith('/login')) {
    return '/auth';
  }
  return `/auth?returnTo=${encodeURIComponent(returnTo)}`;
}

export function safeReturnTo(value: string | null): string {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/auth') || value.startsWith('/login')) {
    return '/';
  }
  return value;
}
